// src/features/scope_module/components/RightPanel.js
import React from 'react';
import { useScope } from '../../../contexts/DemoScopeContext';
import { BarChart3, Info } from 'lucide-react';
import EquilibriumAnalysis from './EquilibriumAnalysis';

function RightPanel() {
  const { analysisResults } = useScope();

  const equilibriumMetrics = analysisResults?.metrics?.equilibrium_metrics || null;

  if (!equilibriumMetrics) {
    return (
      <div className="right-panel">
        <div className="panel-header">
          <BarChart3 size={18} />
          <h3>Analysis</h3>
        </div>
        <div className="equilibrium-panel">
          <div className="equilibrium-metric" style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '0.75rem',
            padding: '1rem'
          }}>
            <Info size={18} style={{ color: 'var(--text-secondary)', flexShrink: 0 }} />
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
              Complete the session and run Analyze to view equilibrium metrics.
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="right-panel">
      <div className="panel-header">
        <BarChart3 size={18} />
        <h3>Analysis</h3>
        {equilibriumMetrics._source === 'local' && (
          <span style={{
            marginLeft: 'auto',
            fontSize: '0.7rem',
            padding: '0.25rem 0.5rem',
            borderRadius: '4px',
            background: 'var(--background-primary-alt)',
            border: '1px solid var(--border-color)',
            color: 'var(--text-secondary)'
          }}>
            Local
          </span>
        )}
      </div>
      <EquilibriumAnalysis metrics={equilibriumMetrics} />
    </div>
  );
}

export default RightPanel;
